import styled from 'styled-components';
import tw from 'twin.macro';
import { Title } from '../../styled components/Typography';

export default styled(Title).attrs({
  as: 'h3'
})(() => [tw`text-center mb-16`]);
